export const maxInputLength = 230
